import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RootScopeDeclare } from '../../core/rootscope-declare';
import { RootScopeService } from '../../core/shared-service/root-scope.service';

@Component({
  selector: 'app-customized-hint',
  templateUrl: './customized-hint.component.html',
  styleUrls: ['./customized-hint.component.scss']
})
export class CustomizedHintComponent implements OnInit {
  @Output() callOnPositiveBtnClick: EventEmitter<string> = new EventEmitter();
  @Input() hintsMsg: any;

  rootScopeData: RootScopeDeclare;
  isRtl: boolean;

  constructor(private rootScopeService: RootScopeService) {
    this.getRootScopeData();
  }

  ngOnInit(): void {
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => this.rootScopeData = rootScopeData);
  }

  closeHint(): void {
    this.callOnPositiveBtnClick.emit();
  }

  stopBubbling(e: Event) {
    e.stopPropagation();
  }

}
